import Modal from '../../components/modal/index';
import VMasker from 'vanilla-masker/lib/vanilla-masker';
import { telMask, MaskPhone } from '../../components/maskPhone';
import { API_PATH } from '../../constants';

(() => {
  const selectors = {
    inpName: document.getElementById('inp-name'),
    inpEmail: document.getElementById('inp-email'),
    inpPhone: document.getElementById('inp-phone'),
    inpCompany: document.getElementById('inp-company'),
    inpOptinTel: document.getElementById('optin_tel'),
    inpOptinSMS: document.getElementById('optin_sms'),
    inpOptinWhatsapp: document.getElementById('optin_whatsapp'),
    inpOptinEmail: document.getElementById('optin_email'),
    submit: document.getElementById('btn-send'),
    btnOk: document.getElementById('btn-ok'),
    msgSuccess: document.getElementById('modal-message__desc'),
    msgStatus: document.getElementById('modal-message__status'),
    modalMessage: '#modal-message'
  };

  const messages = {
    ok: 'Sucesso, mensagem enviada!',
    failed: 'Oops, tente novamente mais tarde.'
  };

  const cssClasses = {
    errorClass: 'error',
    loading: 'is-loading',
    success: 'icon-status--success',
    failed: 'icon-status--failed'
  };

  const modal = new Modal(selectors.modalMessage, false);

  VMasker(selectors.inpPhone).maskPattern(telMask[0]);
  selectors.inpPhone.addEventListener('input', MaskPhone.bind(undefined, telMask, 14), false);

  if (selectors.btnOk != null) {
    selectors.btnOk.addEventListener('click', () => modal.closeModal());
  }

  document.onkeyup = (evt) => {
    if (evt.keyCode === 13) validate();
  }

  selectors.submit.addEventListener('click', (evt) => {
    evt.preventDefault();
    validate();
  });

  function validate() {
    if (selectors.inpName.value.length > 1) {
      selectors.inpName.classList.remove(cssClasses.errorClass);
    } else {
      selectors.inpName.classList.add(cssClasses.errorClass);
    }

    if (selectors.inpEmail.value.length > 1) {
      selectors.inpEmail.classList.remove(cssClasses.errorClass);
    } else {
      selectors.inpEmail.classList.add(cssClasses.errorClass);
    }

    if (selectors.inpPhone.value.length > 1) {
      selectors.inpPhone.classList.remove(cssClasses.errorClass);
    } else {
      selectors.inpPhone.classList.add(cssClasses.errorClass);
    }

    if (selectors.inpCompany.value.length > 1) {
      selectors.inpCompany.classList.remove(cssClasses.errorClass);
    } else {
      selectors.inpCompany.classList.add(cssClasses.errorClass);
    }

    if (
      selectors.inpName.value.length > 1 &&
      selectors.inpEmail.value.length > 1 &&
      selectors.inpPhone.value.length > 1 &&
      selectors.inpCompany.value.length > 1
    ) {
      onSend();
    }
  }

  function onSend() {
    const data = {
      name: selectors.inpName.value,
      email: selectors.inpEmail.value,
      phone: selectors.inpPhone.value,
      origin: 'Imobiliárias e Corretoras',
      company: selectors.inpCompany.value,
      uf: window.state,
      optin_tel: selectors.inpOptinTel.checked ? 1 : 0,
      optin_sms: selectors.inpOptinSMS.checked ? 1 : 0,
      optin_whatsapp: selectors.inpOptinWhatsapp.checked ? 1 : 0,
      optin_email: selectors.inpOptinEmail.checked ? 1 : 0,
    };

    selectors.submit.classList.add(cssClasses.loading);

    axios.post(`${API_PATH}/realestate`, data)
      .then((response) => {
        if (response.data.success) {
          selectors.submit.classList.remove(cssClasses.loading);
          selectors.msgStatus.classList.add(cssClasses.success);
          selectors.msgSuccess.innerHTML = messages.ok;
          modal.openModal();
        } else {
          selectors.submit.classList.remove(cssClasses.loading);
          if (selectors.msgStatus != null) selectors.msgStatus.classList.add(cssClasses.failed);
          selectors.msgSuccess.innerHTML = messages.failed;
          modal.openModal();

          console.log('POST Error ->', response.data.message);
        }
      })
      .catch((error) => {
        selectors.submit.classList.remove(cssClasses.loading);
        if (selectors.msgStatus != null) selectors.msgStatus.classList.add(cssClasses.failed);
        selectors.msgSuccess.innerHTML = messages.failed;
        modal.openModal();

        console.warn('Realestate onSend() Error', error)
      });
  }
})();